export default __webpack_public_path__ + "static/media/GPay_Acceptance_Mark_800.c552fc50.png";